import * as React from 'react';
import { Box, Group, Button, NumberInput, TextInput, Select } from '@mantine/core'
import  { useForm, isNotEmpty } from "@mantine/form";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { showMessage } from "../../lib/notification";
import type { IResponse } from "../../types/api";
import type { IContact } from "./types";
import { contactTypes } from "./constants";
import Page from "../../components/layout/Page";
import { useFormStyles } from "../../styles/form";

interface FormValues extends Pick<IContact, 'label' | 'type' | 'text' | 'value' | 'order'> {

}

const CreateCategory = () => {

    const { classes } = useFormStyles();
    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            label: '',
            order: 0,
            text: '',
            type: 'text',
            value: ''
        },
        validate: {
            type: isNotEmpty('Төрөл сонгоно уу'),
            label: isNotEmpty('Түлхүүр үг оруулна уу'),
            text: isNotEmpty('Текст оруулна уу'),
            value: isNotEmpty('Утга оруулна уу'),
            order: isNotEmpty('Дараалал оруулна уу'),
        },
    });

    const handleSubmit = async (values: FormValues) => {
        const { data } = await axios.post<IResponse<any>>(API_ROUTE, values);
        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green');
        } else {
            showMessage('Алдаа гарлаа');
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE}`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto" my={'xl'}>
                    <form onSubmit={form.onSubmit(handleSubmit)} className={classes.form}>
                        <Select
                            withAsterisk
                            data={contactTypes}
                            label={'Төрөл'}
                            {...form.getInputProps('type')}
                        />

                        <TextInput
                            withAsterisk
                            autoComplete='off'
                            label="Түлхүүр үг"
                            placeholder="Түлхүүр үг оруулна уу"
                            {...form.getInputProps('label')}
                        />

                        <TextInput
                            withAsterisk
                            autoComplete='off'
                            label="Текст"
                            placeholder="Текст оруулна уу"
                            {...form.getInputProps('text')}
                        />

                        <TextInput
                            withAsterisk
                            autoComplete='off'
                            label="Утга"
                            placeholder="Утга оруулна уу"
                            {...form.getInputProps('value')}
                        />

                        <NumberInput
                            withAsterisk
                            label="Дараалал"
                            placeholder="Дараалал"
                            {...form.getInputProps('order')}
                        />
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default CreateCategory;